export const SlaContractStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
} as const;

export type SlaContractStatus =
  (typeof SlaContractStatus)[keyof typeof SlaContractStatus];
